import { getUuid } from '@sibe/utilities/common';
import type { HsGraphics } from '../../graphic-render-new/graphics.class';
import { HsGraphicLines } from '../../graphic-render-new/objects/graphic-lines.class';
import type { HsColor } from '../../math-new/objects/color.class';
import type { HsBox } from '../../math-new/shapes/box.class';
import { hsMakeGeometry } from '../geometry-utils/make-geometry.function';
import type { HsRegularGeometryData } from '../geometry-utils/regular-geometry-data.class';
import { hsGenerateLineCubeGeometryData } from '../primitives/generate-line-cube-geometry-data.function';
import { HsHelper } from './helper.class';

/**
 * Handles s box helper.
 */
export class HsBoxHelper extends HsHelper {
  constructor(graphics: HsGraphics, box: HsBox, color: HsColor) {
    super();
    this.makeMaterial(graphics.gl, color);
    this.makeGeometry(graphics, box);
  }

  public makeLines(): HsGraphicLines {
    if (this.material === null || this.geometry === null) {
      throw new Error('BoxHelper: missing material or geometry');
    }
    const lines: HsGraphicLines = new HsGraphicLines(getUuid(), 'sphereLines', this.geometry, this.material);
    return lines;
  }

  private makeGeometry(graphics: HsGraphics, box: HsBox): void {
    if (this.geometry !== null) {
      return;
    }
    const geometryData: HsRegularGeometryData | null = hsGenerateLineCubeGeometryData(box);
    this.geometry = hsMakeGeometry(graphics, geometryData);
  }
}
